import { type Repair as UBIFRepair } from '@service-initiation/shared-clients-tech-care-services';

import { type Repair } from '../types/Repair';
import { ubifRepairTypeToTechCareRepairType } from './ubifRepairTypeToTechCareRepairType';

export const ubifRepairToTechCareRepair = (ubifRepair: UBIFRepair): Repair => ({
  defaultTagline: ubifRepair.default_tagline.us_en,
  enforcePriceMax: ubifRepair.enforce_price_max,
  enforcePriceMaxCa: ubifRepair.enforce_price_max_ca,
  id: ubifRepair.id,
  imageLink: ubifRepair.image_link,
  metaDescription: ubifRepair.meta_description.us_en,
  name: ubifRepair.name.us_en,
  nationalPrice: ubifRepair.national_price.us_en,
  repairType: ubifRepairTypeToTechCareRepairType(ubifRepair.repair_type),
  rtEligibleCa: ubifRepair.rt_eligible_ca,
  rtEligibleUs: ubifRepair.rt_eligible_us,
  shortDescription: ubifRepair.short_description.us_en,
  sortOrder: ubifRepair.sort_order,
  tagline: ubifRepair.tagline.us_en,
  thumbnailLink: ubifRepair.thumbnail_link,
  visibility: ubifRepair.visibility,
});
